/* Fixed campaign deadline: Europe/Bucharest UTC+02:00, no rolling timer. */
(function () {
  const end = Date.parse('2026-11-08T23:59:00+02:00');
  let interval;
  function update() {
    const left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    if (!left) {
      document.querySelectorAll('[data-asbf26]').forEach(el => { el.hidden = true; });
      document.querySelectorAll('[data-asbf26-fallback]').forEach(el => { el.hidden = false; });
      if (interval) clearInterval(interval);
      window.dispatchEvent(new Event('resize'));
      return;
    }
    const values = {days: Math.floor(left/86400), hours: Math.floor(left/3600)%24, minutes: Math.floor(left/60)%60, seconds:left%60};
    document.querySelectorAll('[data-asbf26-clock]').forEach(clock => {
      Object.entries(values).forEach(([key,value]) => {
        const target=clock.querySelector('[data-asbf26-time="'+key+'"]');
        if(target) target.textContent=String(value).padStart(2,'0');
      });
    });
  }
  interval=setInterval(update,1000);
  update();
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
})();
